module.exports = __webpack_public_path__ + "static/media/bg-take-prize.03d79174.png";